import { useEffect, useState } from "react";

export function useFetch<T>(
  resource: string,
  info?: Request,
  init?: RequestInit
): [T | undefined, (data?: any, id?: string) => Promise<T>] {
  const [response, setResponse] = useState<T>();

  async function request(data?: any, id: string = ""): Promise<T> {
    const r = await fetch(process.env.REACT_APP_API_URL + resource + id, {
      ...(data ? { body: JSON.stringify(data), method: "POST" } : {}),
      ...{
        headers: {
          "Content-Type": "application/json",
          "Access-Control-Allow-Origin": "*",
        },
      },
      ...init,
    });

    const json = await r.json();
    setResponse(json);

    return json;
  }

  return [response, request];
}
